import { map } from "lodash"
import { ILookupItem } from "../../types/genericTypes"

export const transformForLookupList = (list: any[], displayFieldName: string): ILookupItem[] => {
    return map(list, (item) => {
        return {
            id: item.id,
            name: item[displayFieldName]
        }
    })
}

export const getIdArrayFromObjectList = (list: any[], idField: string): string[] => {
    return map(list, (item) => item[idField]);
}